module.exports = __webpack_public_path__ + "static/media/546SunsetAveNW_2018-06-06_56.29603e3d.jpg";